import { boxFromLayout, ImagePinComponentRenderer } from '@lessonup/pin-renderer';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { FocusMode } from '../../store/playerStoreFocusMode.types';
import { FocusModeSpinner } from './FocusModeSpinner';

export type FocusModeScreenProps = {
  focusMode: FocusMode;
  className?: string;
  renderSpinner?: (focusMode: Extract<FocusMode, { type: 'SPINNER' }>) => React.ReactNode;
};

export const FocusModeScreen: React.FC<FocusModeScreenProps> = ({ focusMode, className, renderSpinner }) => {
  return (
    <FocusModeWrapper className={className}>
      <FocusModeSwitch focusMode={focusMode} renderSpinner={renderSpinner} />
    </FocusModeWrapper>
  );
};

type FocusModeSwitchProps = {
  focusMode: FocusMode;
  renderSpinner?: (focusMode: Extract<FocusMode, { type: 'SPINNER' }>) => React.ReactNode;
};

export const FocusModeSwitch: React.FC<FocusModeSwitchProps> = ({ focusMode, renderSpinner }) => {
  switch (focusMode.type) {
    case 'SPINNER':
      if (renderSpinner) return renderSpinner(focusMode);
      return (
        <FocusModeSpinner
          focusMode={focusMode}
          onSpinningChange={(isSpinning) => console.log('isSpinning', isSpinning)}
        />
      );
    case 'IMAGE': {
      const box = boxFromLayout(focusMode.pinComponent.layout);
      return (
        <div style={{ height: box.size.height, width: box.size.width }}>
          <ImagePinComponentRenderer settings={focusMode.pinComponent.settings} layout={box} />
        </div>
      );
    }
    default:
      return null;
  }
};

const FocusModeWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background-color: black;
`;
